import { Button, Col, Text } from 'components';
import { theme } from 'lib';
import React from 'react';
import { TableComponents } from 'screens/Admin/components';
import { ShoutoutFromAthleteListItem } from './';

const ShoutoutFromAthleteList = ({ data, onClick, dataId, loading }) => {
  return (
    <Col wid="100%">
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          wid="200px"
          marg="40px 20px 25px 0"
          big
          text="Add Tier"
          icon="add"
          onClick={onClick}
          bg={theme.SECONDARY}
        />
      </div>

      <TableComponents.List
        maxTableHeight="40vh"
        minTableHeight="250px"
        loading={loading || !data}
        Header={() => (
          <React.Fragment>
            <TableComponents.Th first width100>
              <Text wid="250px">Tier</Text>
            </TableComponents.Th>

            <TableComponents.Th width100>
              <Text right wid="120px">
                United States
              </Text>
            </TableComponents.Th>

            <TableComponents.Th width100>
              <Text right wid="120px">
                Italy
              </Text>
            </TableComponents.Th>

            <TableComponents.Th width100>
              <Text right wid="120px">
                Japan
              </Text>
            </TableComponents.Th>

            <TableComponents.Th width100>
              <Text right wid="120px">
                Macedonia
              </Text>
            </TableComponents.Th>

            <TableComponents.Th width100>
              <Text right wid="120px">
                Athlete's Fee
              </Text>
            </TableComponents.Th>

            <TableComponents.Th width100>
              <Text center wid="120px">
                Service Fee
              </Text>
            </TableComponents.Th>

            <TableComponents.Th last width100>
              <Text wid="50px"></Text>
            </TableComponents.Th>
          </React.Fragment>
        )}
        Items={() =>
          !loading && data
            ? data.map((item, i) => (
                <ShoutoutFromAthleteListItem
                  key={i}
                  dataId={dataId}
                  onClick={onClick}
                  item={item}
                />
              ))
            : null
        }
      />
    </Col>
  );
};

export default ShoutoutFromAthleteList;
